<template>
  <div>
    <v-menu :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <span
          class="d-inline-flex align-center filter-title"
          :class="{ 'font-weight-bold': isFilterApplied }"
          v-on="on"
          v-bind="attrs"
        >
          <v-icon left>
            tag
          </v-icon>
          Hashtags
          <v-icon>
            expand_more
          </v-icon>
        </span>
      </template>
      <v-card>
        <v-card-text class="black--text">
          <div class="mb-3">
            <v-icon class="mr-1 black--text">tag</v-icon>
            Hashtags
          </div>

          <v-text-field
            v-model="form.hashtag"
            label="Add hashtag"
            dense
            outlined
            @keyup.enter="submitForm"
          ></v-text-field>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
const originalForm = () => ({
  hashtag: ""
})

export default {
  name: "FilterHashtags",

  props: {
    moduleId: {
      type: [Symbol, String, Number],
      required: true
    }
  },

  data: () => ({
    form: originalForm()
  }),

  computed: {
    textValue() {
      return this.form.hashtag
    },

    isFilterApplied() {
      return Boolean(this.$store.getters["paidCollaborations/findFilterByType"](this.moduleId, "hashtag"))
    }
  },

  validations: {
    form: {}
  },

  methods: {
    resetForm() {
      this.form = originalForm()
    },

    async submitForm() {
      await this.$v.$touch()

      if (this.$v.$anyError) return

      this.$store.dispatch("paidCollaborations/addFilter", {
        id: this.moduleId,
        type: "hashtag",
        data: {
          color: "blue lighten-5",
          icon: "tag",
          iconColor: "blue",
          text: this.textValue,
          inputs: {
            ...this.form
          }
        }
      })

      this.resetForm()
    }
  }
}
</script>
